import { Editor } from "@tiptap/react";
import React, { useState } from "react";
import Bold from "@icons/RichTextActionBar/bold.svg";
import Italic from "@icons/RichTextActionBar/italic.svg";
import UnorderedList from "@icons/RichTextActionBar/unordered-list.svg";
import { ActionButton, CustomCard } from "./style";

interface IRichTextActionBarProps {
  editor: Editor | null;
}

const RichTextActionBar: React.FC<IRichTextActionBarProps> = ({ editor }) => {
  const [isBoldActive, setIsBoldActive] = useState<boolean>(false);
  const [isItalicActive, setIsItalicActive] = useState<boolean>(false);
  const [isBulletListActive, setIsBulletListActive] = useState<boolean>(false);

  if (editor) {
    editor.on("transaction", (event) => {
      const { editor: editorInstance } = event;
      setIsBoldActive(editorInstance.isActive("bold"));
      setIsItalicActive(editorInstance.isActive("italic"));
      setIsBulletListActive(editorInstance.isActive("bulletList"));
    });

    editor.on("blur", () => {
      setIsBoldActive(false);
      setIsItalicActive(false);
      setIsBulletListActive(false);
    });
  }

  return (
    <CustomCard>
      <ActionButton
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => editor?.chain().focus().toggleBold().run()}
        disabled={!editor?.can().chain().focus().toggleBold().run()}
        className={isBoldActive ? "is-active" : ""}
        type="button"
      >
        <img src={Bold} width={24} height={24} alt="Bold Text" />
      </ActionButton>
      <ActionButton
        onMouseDown={(event) => event.preventDefault()}
        type="button"
        onClick={() => editor?.chain().focus().toggleItalic().run()}
        disabled={!editor?.can().chain().focus().toggleItalic().run()}
        className={isItalicActive ? "is-active" : ""}
      >
        <img src={Italic} width={24} height={24} alt="Italic Text" />
      </ActionButton>
      <ActionButton
        onMouseDown={(event) => event.preventDefault()}
        type="button"
        disabled={!editor?.can().chain().focus().toggleBulletList().run()}
        onClick={() => editor?.chain().focus().toggleBulletList().run()}
        className={isBulletListActive ? "is-active" : ""}
      >
        <img
          src={UnorderedList}
          width={24}
          height={24}
          alt="Add Unordered List"
        />
      </ActionButton>
    </CustomCard>
  );
};

export default RichTextActionBar;
